module.exports = __webpack_public_path__ + "img/logo-sm.4f8a7386.png";